import { css } from 'lit';
export default css `
  p {
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: -0.1px;
  }
`;
//# sourceMappingURL=styles.js.map